import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { Banner, Card, CategoryCard, Hero, HighlightsRow, OnNowRow, PSGRow, PlayersRow, ReplayRow, Row, SquareRow, FeaturedRow, WSCRow, } from "core.components";
import { HomeRows } from "./HomeRows";
import { demoVideos } from "./demoVideos";
import { heroGames } from "./heroGames";
export class Home extends Lightning.Component {
    constructor() {
        super(...arguments);
        this.Rows = this.getByRef("Rows");
    }
    static _template() {
        return {
            h: 1080,
            w: 1920,
            rect: true,
            color: 0xff161616,
            Rows: {
                x: 115,
                alwaysScroll: true,
                // @ts-expect-error: @lightningjs/ui-components 2.25.1 omits style from Column's template types.
                style: {
                    itemSpacing: HomeRows.SPACING,
                    itemTransition: {
                        duration: 0.75,
                        timingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
                    },
                },
                type: HomeRows,
            },
        };
    }
    static async getData(page) {
        // Most cards use Lens–Lyon, with explicit live and Ligue 3 selections below.
        // Android resolves these URLs to bundled MP4s.
        const demoVideoUrl = demoVideos.lensLyon;
        // eslint-disable-next-line no-param-reassign
        page.rails = [
            { type: Hero, items: heroGames(demoVideos.psgMarseille) },
            {
                extraItemSpacing: 16,
                h: 54 + Card.H,
                items: [
                    {
                        description: "Olympique Lyonnais vs OCG Nice",
                        duration: "2:17:22",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/lyon-vs-nice.jpg"),
                    },
                    {
                        description: "Paris FC vs Stade Rennais",
                        duration: "2:33:59",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/paris-vs-rennes.jpg"),
                    },
                    {
                        description: "FC Lorient vs AS Monaco",
                        duration: "2:18:12",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/lorient-vs-monaco.jpg"),
                    },
                    {
                        description: "Havre AC vs AJ Auxerre",
                        duration: "2:18:01",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/havre-vs-auxerre.jpg"),
                    },
                    {
                        description: "Angers SCO vs Olympique De Marseille",
                        duration: "2:17:22",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/angers-vs-marseille.jpg"),
                    },
                    {
                        description: "Estac Troyes vs RC Lens",
                        duration: "2:17:22",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/latest-replay/troyes-vs-lens.jpg"),
                    },
                ],
                title: "Latest Replay",
                type: ReplayRow,
            },
            {
                type: Row,
                title: "Latest Highlights",
                h: 54 + Card.H,
                extraItemSpacing: 16,
                items: [
                    ["PSG vs Olympique Lyonnais", "psg-vs-lyon.jpg"],
                    ["Marseille vs Havre AC", "marseille-vs-havre.jpg"],
                    ["FC Lorient vs Angers SCO", "lorient-vs-angers.jpg"],
                    ["Le Mans FC vs AJ Auxerre", "le-mans-vs-auxerre.jpg"],
                    ["Rennes vs Strasbourg", "rennes-vs-strasbourg.jpg"],
                    ["AS Monaco vs LOSC", "monaco-vs-losc.png"],
                ].map(([description, artwork]) => ({
                    description,
                    href: demoVideoUrl,
                    posterSrc: Utils.asset(`images/latest-highlights/${artwork}`),
                })),
            },
            {
                type: HighlightsRow,
                title: "Matchday Highlights",
                extraItemSpacing: 128,
                items: [
                    {
                        description: "Olympique Lyonnais v OGC Nice",
                        artwork: "lyon-vs-nice.jpg",
                    },
                    {
                        description: "Paris FC v Stade Rennais",
                        artwork: "paris-vs-rennes.jpg",
                    },
                    {
                        description: "Troyes v Marseille",
                        artwork: "troyes-vs-marseille.jpg",
                    },
                    {
                        description: "Stade Rennais v AJ Auxerre",
                        artwork: "rennes-vs-auxerre.jpg",
                    },
                    { description: "PSG v Le Mans", artwork: "psg-vs-le-mans.jpg" },
                    {
                        description: "OGC Nice v Strasbourg",
                        artwork: "nice-vs-strasbourg.jpg",
                    },
                ].map(({ description, artwork }) => ({
                    description,
                    href: demoVideoUrl,
                    posterSrc: Utils.asset(`images/highlights/${artwork}`),
                })),
            },
            {
                h: FeaturedRow.H,
                items: [
                    {
                        description: "Paris 13 Atletico vs FC Rouen",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/paris-13-vs-rouen.jpg"),
                    },
                    {
                        description: "Quevilly-Rouen vs Orléans",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/quevilly-rouen-vs-orleans.jpg"),
                    },
                    {
                        description: "Villefranche vs Cannes",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/villefranche-vs-cannes.jpg"),
                    },
                    {
                        description: "Aubagne vs Le Puy-en-Velay",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/aubagne-vs-le-puy.jpg"),
                    },
                    {
                        description: "Valencennes vs Amiens",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/valencennes-vs-amiens.jpg"),
                    },
                    {
                        description: "Lask vs Slovan bratislava",
                        href: demoVideos.paris13Rouen,
                        locked: true,
                        posterSrc: Utils.asset("images/featured/lask-vs-slovan-bratislava.jpg"),
                    },
                ],
                title: "The Latest League 3",
                type: FeaturedRow,
            },
            {
                cornerRadius: 60,
                item: {
                    posterSrc: Utils.asset("images/banners/fantasy-league.png"),
                },
                type: Banner,
            },
            {
                type: PSGRow,
                title: "Paris Saint-Germain",
                h: PSGRow.H,
                extraItemSpacing: 16,
                items: [
                    {
                        category: "Highlights",
                        description: "Paris vs Lyon",
                        duration: "01:31",
                        posterSrc: Utils.asset("images/psg/paris-vs-lyon.jpg"),
                    },
                    {
                        category: "Full Match",
                        description: "Paris vs Lyon",
                        duration: "1:42:57",
                        posterSrc: Utils.asset("images/psg/full-match.jpg"),
                    },
                    {
                        category: "Interviews",
                        description: "Post Game Interviews",
                        duration: "02:10",
                        posterSrc: Utils.asset("images/psg/interviews.jpg"),
                    },
                    {
                        category: "Highlights",
                        description: "Paris vs Montpellier",
                        duration: "02:10",
                        posterSrc: Utils.asset("images/psg/paris-vs-montpellier.jpg"),
                    },
                    {
                        category: "Live Interview",
                        description: "Veille Capitale ahead of Paris - Lyon, Live from the Campus",
                        duration: "1:05:22",
                        posterSrc: Utils.asset("images/psg/live-interview.jpg"),
                    },
                    {
                        category: "Inside",
                        description: "Behind the scenes of the Parisians victory over Barca",
                        duration: "07:50",
                        posterSrc: Utils.asset("images/psg/inside.png"),
                    },
                ].map((item) => (Object.assign(Object.assign({}, item), { href: demoVideoUrl }))),
            },
            {
                items: [
                    {
                        description: "Angers",
                        logoSrc: Utils.asset("images/clubs/angers.png"),
                    },
                    {
                        description: "Le Mans",
                        logoSrc: Utils.asset("images/clubs/le-mans.png"),
                    },
                    {
                        description: "Lens",
                        logoSrc: Utils.asset("images/clubs/lens.png"),
                    },
                    {
                        description: "Lorient",
                        logoSrc: Utils.asset("images/clubs/lorient.png"),
                    },
                    {
                        description: "Le Havre",
                        logoSrc: Utils.asset("images/clubs/le-havre.png"),
                    },
                    {
                        description: "Toulouse",
                        logoSrc: Utils.asset("images/clubs/toulouse.png"),
                    },
                ].map((club) => (Object.assign(Object.assign({}, club), { posterSrc: Utils.asset("images/clubs/background.png") }))),
                title: "Clubs",
                type: SquareRow,
                extraItemSpacing: 16,
            },
            {
                type: Row,
                title: "Original Documentaries",
                h: 54 + Card.H,
                extraItemSpacing: 16,
                items: [
                    ["Rosenior On Air", "rosenior-on-air.jpg"],
                    ["Moïse Bombito Made in Montréal", "moise-bombito.png"],
                    ["99 Minutes to Dream", "99-minutes-to-dream.jpg"],
                    ["Sebastian Before Nanasi", "seb-before-nanasi.jpg"],
                    ["What goes on in the changing room", "changing-room.jpg"],
                    ["Lucas Chevalier", "lucas-before-chevalier.jpg"],
                ].map(([description, artwork]) => ({
                    description,
                    href: demoVideoUrl,
                    posterSrc: Utils.asset(`images/original-documentaries/${artwork}`),
                })),
            },
            {
                type: OnNowRow,
                extraItemSpacing: 71.547,
                items: [
                    {
                        heading: "On Now",
                        title: "PSG v Marseille",
                        time: "20:00 - 21:50",
                        progress: 0.5,
                        href: demoVideos.psgMarseille,
                    },
                    {
                        heading: "Up Next",
                        title: "French rivals | PSG - OM",
                        time: "21:50 - 22:15",
                    },
                    {
                        heading: "On Later",
                        title: "Paris FC v AS Monaco",
                        time: "22:15 - 00:10",
                    },
                    {
                        title: "Ligue 1 — The Weekend Goals",
                        time: "00:10 - 00:25",
                    },
                    {
                        title: "Olympique Marseille v Toulouse FC",
                        time: "00:25 - 02:20",
                    },
                ],
            },
            {
                cornerRadius: 100,
                item: {
                    posterSrc: Utils.asset("images/banners/gameday-tickets.jpg"),
                },
                type: Banner,
            },
            {
                title: "Main Stories",
                type: WSCRow,
                items: [
                    {
                        title: "Kylian Mbappé",
                        description: "Leaves Lille Reeling",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/main-stories/kylian-mbappe.jpg"),
                    },
                    {
                        title: "OM’s Best Goals",
                        description: "against Le Havre",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/main-stories/om-best-goals.jpg"),
                    },
                    {
                        title: "Ajorque involved in",
                        description: "all four goals",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/main-stories/ajorque-four-goals.jpg"),
                    },
                    {
                        title: "Carlos Eduardo",
                        description: "Day of Glory",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/main-stories/carlos-eduardo.jpg"),
                    },
                    {
                        title: "Osimhen The star",
                        description: "Who Emerged at LOSC",
                        href: demoVideoUrl,
                        posterSrc: Utils.asset("images/main-stories/osimhen-losc.jpg"),
                    },
                ],
            },
            {
                title: "Categories",
                type: Row,
                cardType: CategoryCard,
                headingFontFace: "Lato",
                headingHeight: 59,
                h: 79 + CategoryCard.H,
                items: [
                    { title: "Replays", icon: "replays" },
                    { title: "Highlights", icon: "highlights" },
                    { title: "Schedule", icon: "schedule" },
                ],
            },
            {
                type: PlayersRow,
                title: "Paris Saint Germain Players",
                h: PlayersRow.H,
                items: [
                    ["Ousmane Dembélé", "dembele"],
                    ["Désiré Doué", "doue"],
                    ["Marquinhos", "marquinhos"],
                    ["Fabián Ruiz", "ruiz"],
                    ["Achraf Hakimi", "hakimi"],
                    ["Lucas Beraldo", "beraldo"],
                ].map(([title, artwork]) => ({
                    title,
                    description: "",
                    posterSrc: Utils.asset(`images/psg-players/${artwork}.png`),
                })),
            },
        ];
    }
    set rails(rails) {
        // Clear out any old rails...
        while (this.Rows.items.length) {
            this.Rows.removeItemAt(0);
        }
        // ...before we set the new ones...
        this.Rows.appendItems(rails);
        // ...and finally recalculate the focus.
        this._refocus();
    }
    _getFocused() {
        return this.Rows;
    }
    _init() {
        this.Rows.scrollFollower = this.widgets.navbar;
    }
    _onMounted() {
        Router.restoreFocus();
    }
    historyState(state) {
        var _a, _b;
        if (state) {
            // The retained Home instance already remembers each rail's selected card.
            // Restore only whether focus belonged to that content or the Navbar.
            if (state.navbarFocused)
                Router.focusWidget("Navbar");
            else
                Router.restoreFocus();
            return state;
        }
        return { navbarFocused: (_b = (_a = Router.getActiveWidget()) === null || _a === void 0 ? void 0 : _a.hasFocus()) !== null && _b !== void 0 ? _b : false };
    }
    _handleUp() {
        Router.focusWidget("Navbar");
        return true;
    }
}
export default Home;
//# sourceMappingURL=Home.js.map